import type { RouteObject } from "react-router";
import { VIDEO_ROUTES } from "../constants/video-routes";
import { VideoRouteLayout } from "../layouts/video-route-layout";

export const videoRoutes: RouteObject = {
	element: <VideoRouteLayout />,
	children: [
		{
			path: VIDEO_ROUTES.ROOM,
			lazy: async () => {
				const { default: VideoRoomPage } = await import("../pages/video-room-page");
				return { Component: VideoRoomPage };
			},
		},
	],
};
